<template src='./pif1-5-0.html'></template>

<script>
import Vue from 'vue'
// import { EventBus } from '@/router/bus'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { JSONEditor } from '@json-editor/json-editor/'

// const DISPLAY = 'display'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      markFields: 18,
      showErrorPanel: false,
      validationErrors: [],
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      resultContent: null,
      initialSchema: {},
      initialEditor: {},
      initialConfig: {},
      initialVal: {},
      initialMarks: {},
      pif: null,
      errorPanel: null,
      editor: {},
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      phaseFormId: this.$route.params.phaseFormId,
      formId: null,
      project: {},
      projectForm: null,
      loading: false,
      ProjectStatus: {
        DRAFT: 1,
        CREATED: 2,
        ACCEPTED: 3
      },
      status: [
        {
          color: 'pending',
          text: this.$t('projects.formStatuses.1')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.2')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.3')
        },
        {
          color: 'success',
          text: this.$t('projects.formStatuses.4')
        }
      ]
    }
  },
  methods: {
    validateFormInput () {
      const errors = this.editor.validate()
      if (errors && errors.length > 0) {
        this.validationErrors = errors
        this.showErrorPanel = true
        this.$nextTick(function () {
          this.scrollToErrorPanel()
        })
      }
    },
    // submitFormInput () {
    //   this.loading = true
    //   const editors = {}
    //   for (let i = 0; i < this.markFields; i++) {
    //     const value = this.editor.getEditor('root.' + (i + 1) + '.input').getValue()
    //     if (value) {
    //       editors[(i + 1) + '.input'] = value
    //     }
    //   }
    //   this.projectForm = {
    //     projectCode: this.projectCode,
    //     projectPhaseId: this.projectPhaseId,
    //     formId: this.formId,
    //     json: JSON.stringify(editors)
    //   }
    //   this.$http.post(Vue.$apiConfig.projectInputFormPost, this.projectForm)
    //     .then(
    //       response => {
    //         this.logConsole(response)
    //         EventBus.$emit('alert', {
    //           variant: 'success',
    //           message: this.$t('projects.submitProjectFormInputSuccessful'),
    //           errors: []
    //         })
    //         this.loading = false
    //       },
    //       error => {
    //         this.formatErrorResponse(error)
    //         this.loading = false
    //       }
    //     )
    // },
    // markFormInput () {
    //   this.loading = true
    //   const markeditors = {}
    //   for (let i = 0; i < this.markFields; i++) {
    //     markeditors[(i + 1) + '.mark'] = this.editor.getEditor('root.' + (i + 1) + '.mark').getValue()
    //     // markeditors[(i + 1) + ' mark.comment'] = this.editor.getEditor('root.' + (i + 1) + ' mark').getValue().comment
    //   }
    //   this.projectForm = {
    //     projectCode: this.projectCode,
    //     formId: this.formId,
    //     json: JSON.stringify(markeditors)
    //   }
    //   this.$http.post(Vue.$apiConfig.projectInputFormPost, this.projectForm)
    //     .then(
    //       response => {
    //         this.logConsole(response)
    //         EventBus.$emit('alert', {
    //           variant: 'success',
    //           message: this.$t('projects.markProjectFormInputSuccessful'),
    //           errors: []
    //         })
    //         this.loading = false
    //       },
    //       error => {
    //         this.formatErrorResponse(error)
    //         this.loading = false
    //       }
    //     )
    // },
    fetch (query) {
      const queryParamName = 'search'
      const url = this.autoCompleteUrl_budgetId
      const params = Object.assign({ [queryParamName]: query })
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url, { params })

      return Promise.race([cancel, request])
    },
    cancel () {
      // used to 'cancel' previous searches
    },
    setupPage () {
      this.loading = true
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.phaseFormId)
        .then(
          response => {
            const payload = response.data.payload
            const formInput = payload.projectFormInput
            this.formInputId = formInput ? formInput.id : null
            this.formId = payload.projectForm.id
            this.pif = JSON.parse(payload.projectForm.json)
            this.initialSchema = this.pif.schema
            this.initialConfig = this.pif.config
            this.initialVal = formInput.inputJson ? JSON.parse(formInput.inputJson) : null
            this.initializeEditor()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    initializeEditor () {
      const el = document.getElementById('editorHolder')
      this.initialConfig.schema = this.initialSchema
      this.initialConfig.no_additional_properties = true
      // this.initialConfig.schema.definitions.mark.options.hidden = false
      // this.initialConfig.schema.definitions.text.readonly = true
      this.editor = new JSONEditor(el, this.initialConfig)
      this.resultContent = this.initialEditor

      this.editor.on('ready', () => {
        if (this.initialVal) {
          // if (this.initialMarks) { Object.assign(this.initialVal, this.initialMarks) }
          for (const key in this.initialVal) {
            var property = this.editor.getEditor('root.' + key)
            if (property) {
              property.setValue('')
              property.setValue(this.initialVal[key])
            }
          }
        }
      })
      this.editor.element.children[0].children[2].className = 'hidden-panel'
      console.log(this.editor)
    },
    extractErrorItem (message) {
      var regExp = /'[0-9]+'/
      return regExp.exec(message)[0]
    },
    scrollToErrorPanel () {
      const element = this.$refs.errorPanel
      var top = element.offsetTop

      window.scrollTo(0, top)
    }
  },
  created () {
    this.setupPage()
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.autocomplete-result {
  background-image: none !important;
  padding-left: 10px !important;
}
.hidden-panel {
  display: none !important;
}
</style>
